import { Link } from 'gatsby';
import React from 'react';
import BlockContent from '@sanity/block-content-to-react';
import Img from 'gatsby-image';
import { getFluidGatsbyImage } from 'gatsby-source-sanity';
import { renderFormattedDateTime } from '../../utils/utils';
import SocialShareOptions from '../SocialShareOptions/socialShareIcons';
import './postDetails.scss';
import { serializers } from '../../utils/blockMarks';
import clientConfig from '../../../client-config';

const PostDetails = (props) => {
  const {
    context: { nextSlug, prevSlug, pathPrefix },
    content,
  } = props;
  const renderPostHeadline = ({ headlineData }) => {
    return (
      <div className="post-headline-wrapper" key={Math.random().toString(32).substring(7)}>
        <h2 className="post-headline text-title">{headlineData.headline}</h2>
        <small className="post-datetime caption">{renderFormattedDateTime(headlineData?.DateOfPublication)}</small>
      </div>
    );
  };
  const renderPostCustomImage = (customImageData) => {
    return (
      <Img
        key={Math.random().toString(32).substring(7)}
        className="post-image-wrapper"
        fluid={getFluidGatsbyImage(customImageData?.src?.asset?._ref, { maxWidth: 675 }, clientConfig.sanity)}
        alt=""
      />
    );
  };
  const renderPostNextPrev = (next, prev) => {
    return (
      <div className="post-next-prev-wrapper" key={Math.random().toString(32).substring(7)}>
        {typeof window !== 'undefined' && prev === window.location.pathname.split('/')[2] ? (
          <Link to={`${pathPrefix}/`} className="btn btn-outline rotate-180">
            <i className="icon-arrow" /> Back to Blog
          </Link>
        ) : (
          <Link to={`${pathPrefix}/${prev}/`} className="btn btn-outline rotate-180">
            <i className="icon-arrow" /> Read Prev Post
          </Link>
        )}
        {typeof window !== 'undefined' &&
          (window.location.pathname.split('/')[2] !== next ? (
            <Link to={`${pathPrefix}/${next}/`} className="btn btn-outline rotate-0">
              Read Next Post <i className="icon-arrow" />
            </Link>
          ) : (
            ''
          ))}
      </div>
    );
  };
  return (
    <div className="container">
      <div className="post-wrapper">
        {content?.headline && renderPostHeadline({ headlineData: { ...content } })}
        {content?._rawBlogImage && renderPostCustomImage(content?._rawBlogImage)}
        {content?._rawBody?.length > 0 && <BlockContent blocks={content?._rawBody} serializers={serializers} />}
        <SocialShareOptions postURL={typeof window !== 'undefined' ? window.location.href : ''} />
        {content?.showCTA && renderPostNextPrev(nextSlug, prevSlug)}
      </div>
    </div>
  );
};

export default PostDetails;
